module.exports = "/_next/static/pages/about/Fragments/3f2ab6a79a4b2c28a8873fa10c8a95e9.jpg";